if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target)
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            const alreadyAligned =
              Math.abs(activeMedia.parentElement.scrollLeft - activeMedia.offsetLeft) < 2;
            if (!alreadyAligned) {
              activeMedia.parentElement.scrollTo({
                left: activeMedia.offsetLeft,
                behavior: "auto",
              });
            }
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

if (!customElements.get("product-gallery")) {
  customElements.define(
    "product-gallery",
    class ProductGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector(".product-gallery--liveregion"),
          viewer: this.querySelector(".product-gallery--slideshow"),
          thumbnails: this.querySelector(".product-gallery--thumbnails"),
        };

        this.elements.viewer.addEventListener(
          "slideChanged",
          this.onSlideChanged.bind(this)
        );

        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch.addEventListener(
              "click",
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target)
            );
          });

        this.activeVariant = this.closest(".product").querySelector(
          'product-info [name="id"]'
        ).value;

        this.initUniqueVariantImages(this.activeVariant);
      }

      onSlideChanged(event) {
        const current = event.detail && event.detail.currentElement;
        if (!current) return;

        const mediaId = current.dataset.mediaId;
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.toggle(
              "is-active",
              element.dataset.mediaId === mediaId
            );
          });

        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");

        if (!activeMedia) {
          return;
        }

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        activeMedia.classList.add("is-active");

        this.preventStickyHeader();

        const slider = activeMedia.parentElement;
        if (slider) {
          slider.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "auto",
          });
        }
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll(".slider__slide")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.setAttribute("aria-current", true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion || !window.accessibilityStrings) return;
        this.elements.liveRegion.setAttribute("aria-hidden", false);
        this.elements.liveRegion.innerHTML =
          window.accessibilityStrings.imageAvailable.replace(
            "[index]",
            position
          );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute("aria-hidden", true);
        }, 2000);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      parseAltConstraints(alt) {
        const byName = new Map();
        String(alt || "")
          .split(/\s*,\s*(?=[^,:]+:)/)
          .forEach((chunk) => {
            const parts = chunk.split(":");
            for (let i = 0; i + 1 < parts.length; i += 2) {
              const name = parts[i].trim().toLowerCase();
              const values = parts[i + 1]
                .split(",")
                .map((value) => value.trim().toLowerCase())
                .filter((value) => value && value !== "secondary");
              if (!name || !values.length) continue;
              byName.set(name, (byName.get(name) || []).concat(values));
            }
          });
        return byName;
      }

      variantAltTokens(alt) {
        const tokens = [];
        this.parseAltConstraints(alt).forEach((values) => {
          values.forEach((value) => tokens.push(value));
        });
        return tokens;
      }

      optionValueMatches(options, token) {
        return options.some((option) => {
          const value = String(option || "").trim().toLowerCase();
          return value === token;
        });
      }

      mappedOptionValues(name, values, known) {
        const direct = values.filter((value) => known.has(value));
        if (direct.length) return direct;

        const colorByKarat = { gg: "gold", wg: "weißgold", rg: "rosegold" };
        if (name === "karat") {
          return values
            .map((value) => colorByKarat[value.match(/\b(gg|wg|rg)$/)?.[1]])
            .filter((value) => value && known.has(value));
        }
        if (name === "color") {
          return values.flatMap((value) => {
            const suffix = Object.keys(colorByKarat).find(
              (key) => colorByKarat[key] === value
            );
            return suffix
              ? [...known].filter((option) => option.endsWith(` ${suffix}`))
              : [];
          });
        }
        return [];
      }

      variantCheck(options, alt) {
        if (!alt || !alt.includes(":") || alt.split(":")[1] === "") return true;
        const flags = alt
          .toLowerCase()
          .split(/[:,]/)
          .map((part) => part.trim());
        if (
          flags.includes("x") ||
          flags.includes("exclude") ||
          flags.includes("excluded")
        )
          return false;

        const known = this.allOptionValues;
        const selected = (options || []).map((option) =>
          String(option || "").trim().toLowerCase()
        );
        for (const [name, values] of this.parseAltConstraints(alt)) {
          const required = known && known.size
            ? this.mappedOptionValues(name, values, known)
            : values;
          if (required.length === 0) continue;
          if (!required.some((part) => this.optionValueMatches(selected, part))) {
            return false;
          }
        }
        return true;
      }

      initUniqueVariantImages(activeVariant) {
        const galleryMedias = Array.from(this.querySelectorAll("[data-media-alt]"));
        const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
        const modalMedias = modal
          ? Array.from(modal.querySelectorAll("[data-media-alt]"))
          : [];
        this.medias = galleryMedias.concat(modalMedias);
        this.productOptions = JSON.parse(this.dataset.variants);
        this.activeOptions =
          this.productOptions[activeVariant].split("vrlink808");
        this.allOptionValues = new Set(
          Object.values(this.productOptions).flatMap((joined) =>
            String(joined)
              .split("vrlink808")
              .map((option) => option.trim().toLowerCase())
              .filter(Boolean)
          )
        );

        this.variants = [
          ...new Set(
            this.medias.map((element) => element.dataset.mediaAlt)
          ),
        ]
          .filter((item) => item && item.includes(":"))
          .map((item) => item.toLowerCase());

        this.medias.forEach((media) => {
          const alt = media.dataset.mediaAlt || "";
          media.style.setProperty("display", "none", "important");

          if (this.variantCheck(this.activeOptions, alt)) {
            media.style.display = "";
          }
        });

        if (window.__galleryVideosStarted && window.playGalleryVideos) {
          window.playGalleryVideos(this);
        }

        this.elements.viewer.dispatchEvent(
          new CustomEvent("slidersModified", {
            detail: {
              setActive: true,
            },
          })
        );

        this.elements.thumbnails.dispatchEvent(
          new CustomEvent("slidersModified", {
            detail: {
              setActive: true,
            },
          })
        );
      }

      getSelectedRadioValue(radioName) {
        let selectedRadio = document.querySelector(
          `input[name="${radioName}"]:checked`
        );
        return selectedRadio ? selectedRadio.value : null;
      }

      handleizeString(str) {
        if (str) {
          return str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        }
        return "";
      }
    }
  );
}
